import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar from '../EcoClub/Sidebar';
import EcoClub2025 from '../EcoClub2025';


const EnvironmentDay2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/7.webp`;
  const p8  = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/8.webp`;
  const p9  = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/9.webp`;
  const p10 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/10.webp`;
  const p11 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/11.webp`;
  const p12 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/12.webp`;
  const p13 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/13.webp`;
  const p14 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/14.webp`;
  const p15 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/15.webp`;
  const p16 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/16.webp`;
  const p17 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/17.webp`;
  const p18 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/18.webp`;
  const p19 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/19.webp`;
  const p20 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/20.webp`;
  const p21 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/21.webp`;
  const p22 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/22.webp`;
  const p23 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/23.webp`;
  const p24 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/24.webp`;
  const p25 = `${config.base_image_url_2025}/home/events-activities/club/EcoClub/Environment/25.webp`;




  const photos = [
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
},
{
    src: p13,
    source: p13,
    rows: 1,
    cols: 1,
},
{
    src: p14,
    source: p14,
    rows: 1,
    cols: 1,
},
{
    src: p15,
    source: p15,
    rows: 1,
    cols: 1,
},
{
    src: p16,
    source: p16,
    rows: 1,
    cols: 1,
},
{
    src: p17,
    source: p17,
    rows: 1,
    cols: 1,
},
{
    src: p18,
    source: p18,
    rows: 1,
    cols: 1,
},
{
    src: p19,
    source: p19,
    rows: 1,
    cols: 1,
},
{
    src: p20,
    source: p20,
    rows: 1,
    cols: 1,
},
{
    src: p21,
    source: p21,
    rows: 1,
    cols: 1,
},
{
    src: p22,
    source: p22,
    rows: 1,
    cols: 1,
},
{
    src: p23,
    source: p23,
    rows: 1,
    cols: 1,
},
{
    src: p24,
    source: p24,
    rows: 1,
    cols: 1,
},
{
    src: p25,
    source: p25,
    rows: 1,
    cols: 1,
}


  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
      Environment Day
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: PRE-PRIMARY   &  Date: 27 June 2025
        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Where creativity meets care – turning trash into treasure"
<br></br>
        </Typography>

<strong>Whispers of Green – A Celebration of Recycling</strong>
<br></br>
<strong>Nature is not a place to visit. It is home.” – Gary Snyder</strong>
<br></br>
<strong>Environment Day Celebration – Nurturing Young Environmentalists</strong>
<br></br>
        <Typography variant={'subtitle1'} align={'justify'}>
      The Environment Day celebration, conducted on Friday, 27 June 2025, was a resounding success, 
immersing our Pre-Primary students in the wonders of nature through engaging and educational activities. 
The event was thoughtfully designed for children from Montessori-I, II, III, Pre-K, KG-I, and KG-II, ensuring 
age-appropriate and meaningful participation.
      <br></br>
      Each group had the opportunity to learn about the three R`s: - ‘Reduce, Reuse, and Recycle’ through 
captivating storytelling and interactive sessions. The children listened attentively to talks on reducing 
waste and enthusiastically observed creative presentations on reusing and recycling everyday items.
<br></br>
<strong>"Planting the seeds of sustainability in the hearts of our future leaders”</strong>
<br></br>
      These engaging and meaningful activities proved highly beneficial for children, igniting their curiosity and 
creativity while fostering a lasting appreciation for upcycling, conservation, and environmental care. The 
celebration enriched their understanding of ecological responsibility and inspired a sense of wonder and 
empathy toward the planet, laying the groundwork for environmentally conscious attitudes in the future. 
      <br></br>
      <strong>Classroom Highlights – Creations That Spoke Volumes </strong>
      <br></br>
In Kindergarten, Pre-K children played a fun board game using a cardboard box and explored shapes with 
a math sorting activity made from recycled cardboard. KG1A created a lively board game from used 
cardboard and a handy stationery stand from old plastic bottles. KG1B brought a hen toy to life using 
paper cups and gloves and designed an interactive “Aim and Hit” board game with egg cartons. KG2A 
built a delightful bird feeder from cardboard and added charm with colourful paper windmills. KG2B reused 
a plastic bottle to craft a creative pen stand and made playful dice from cardboard. KG2C designed a 
soothing wind chime from recycled materials and constructed a functional clock from cardboard.
<br></br>
In Montessori, Env-A children made a pencil stand with a cardboard box and coloured pencils, and a 
storybook using leftover pages. Env-B children crafted a pencil stand with a plastic bottle and straw, a 
basket from a plastic bottle and fruit netting, and another basket with a paper cup. Env-C children made 
a puppet with socks and a basket with a plastic bottle. In Env-D, children created planters using plastic 
water bottles, coasters with newspaper, and crafts with pencil shavings. Env-E made a bird craft with 
pistachio shells, a wall hanging from cardboard, and a doll with a coconut shell.
<br></br>
These weren’t just art projects—they were quiet conversations between the children and the Earth, gentle 
reflections of care, and powerful first steps toward becoming compassionate caretakers of our planet.
<br></br>
<strong>More Than a Celebration – A Seed of Change </strong>
<br></br>
Throughout the day, the message of the 3 R’s – Reduce, Reuse, Recycle – echoed through the 
classrooms, not as rules, but as a joyful way of life. Through storytelling, songs, hands-on exploration, 
and moments of wonder, our little eco-warriors discovered that even the simplest actions can spark the 
biggest waves of change. 
<br></br>
They saw how things we often throw away can become something beautiful. 
They learned that nature gives—and with love, we can give back.  
<br></br>
As the day drew to a close, we were all deeply moved. What we witnessed was more than just an event—
 it was a quiet revolution, powered by the innocence and hope of children. A reminder that real change 
begins not with grand gestures, but with small hearts full of love, doing small things with great care. 
<br></br>
In a touching gesture, the children from Montessori and Kindergarten presented a handmade card to our 
beloved Principal Ma’am. With bright colours and simple, heartfelt words, the card was more than paper 
and paint—it was a promise from little hearts to protect and cherish our planet, a symbol of gratitude, 
respect, and hope for a greener tomorrow.
<br></br>
<strong>Every small hand can plant a seed, and every small heart can grow a forest of hope.</strong>
<br></br>
On this special Environment Day, the seeds of compassion, creativity, and environmental consciousness 
were lovingly sown—and in the hearts of our Pre-Primary students, they are already beginning to bloom. 
<br></br>

        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Crafted by tiny hands, inspired by Mother Earth"

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <EcoClub2025 />
             </Box>
             <Box marginBottom={4}>
               <Sidebar />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EnvironmentDay2025;